import merge from 'lodash/merge';
import DomainResource from './DomainResource';
import Reference from './types/Reference';

/**
 * One dose poured ahead of its window, keyed to a projected dose rather than a materialized one.
 *
 * `request` and `slot` together are that projection's identity, and are what the generator adopts
 * this by when the window finally opens.
 */
export default class BN_MedPassPrep extends DomainResource {
    static __className = 'BN_MedPassPrep';

    __objectStructure = {
        patient: Reference,
        request: Reference,
        slot: String,
        dayKey: String,
        location: Reference,
        preparedOn: String,
        preparedBy: Reference,
    };

    constructor(constructJson, className = 'BN_MedPassPrep') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
